/**
 * Usage events that identify a consuming treatment cycle. The origin cycle
 * remains on the specimen's top-level cycleId; these events represent later
 * reservation and lifecycle relationships.
 */
export const CONSUMING_SPECIMEN_USAGES: ReadonlySet<string> = new Set([
  "reserve",
  "thaw",
  "use",
  "transfer",
  "fertilize",
]);

/**
 * Usage events that mark the specimen as physically gone from the vault: the
 * eggs have been thawed and fertilized, the embryo has been transferred, the
 * sperm sample has been used. `reserve` is intentionally excluded: older
 * cycles left it to mark material picked for them, which does not physically
 * remove it.
 *
 * The backend does not update `specimen.status` or `storageLocation.isActive`
 * when these events land, so the frontend has to read the event log to keep
 * the vault display honest.
 */
export const PHYSICALLY_CONSUMED_SPECIMEN_USAGES: ReadonlySet<string> = new Set(
  ["thaw", "use", "transfer", "fertilize"],
);
